module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/uz-ba79d2974850ade2d0360e7cd0616f31.svg";